import React, { useEffect } from 'react'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import {
  useGetEmployeeGroup,
  useGetGroupEmployees,
  useRemoveEmployeesFromGroup,
} from '../../../redux/employees/hook/groups'
import {
  employeeStatusConfig,
  PAGINATION_DEFAULT,
} from '../../../utils/constants'
import Button from '../../button'
import DataTable from '../../datatable'
import RunAdvancedPayroll from '../../modal/payroll/run-advanced-payroll'
// import RunBasicPayroll from '../../modal/payroll/run-basic-payroll';
import AddEmployeeToGroup from '../../modal/employees/add-employee-to-group'
import { useSelector } from 'react-redux'
import { useGetEmployeeSalaries } from '../../../redux/employees/hook/salaries'
import { store } from '../../../redux'
import { setAlert } from '../../../redux/components/components-slice'
import { useGetEmployees } from '../../../redux/employees/hook'
import RunBasicPayroll from '../../modal/payroll/run-basic-payroll'

const GroupOverviewTab = () => {
  useEffect(() => {}, [])
  const { section } = useSelector((state) => state.sectionSlice)
  const { user } = useSelector((state) => state.userSlice)

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })

  const { data: employeeSalaries } = useGetEmployeeSalaries(2, 1, 1, '')
  const { id } = useParams()

  const { data: group_employees } = useGetGroupEmployees(
    id,
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  )

  const { data: group } = useGetEmployeeGroup(id)

  const { data: employees } = useGetEmployees(2, 1, 1, '')

  // const [showBasicPayrollOptions, setShowBasicPayrollOptions] = useState(false);
  const [showAdvancedPayrollOptions, setShowAdvancedPayrollOptions] =
    useState(false)
  const [showAddEmployeeToGroup, setShowAddEmployeeToGroup] = useState(false)
  const { mutateAsync: removeFromGroup } = useRemoveEmployeesFromGroup()
  const [basicPayroll, setBasicPayroll] = useState(false)

  const removeEmployeesFromGroup = (id) => {
    let index = group_employees.data.findIndex((item) => item.id == id)
    let payload = {
      group: group_employees.id,
      employees: group_employees.data[index].employee,
    }
    removeFromGroup(payload)
  }

  const tableConfig = {
    headers: ['Date Added', 'Employee Name', 'Email', 'Mobile', 'Status'],
    keys: [
      'created',
      'employeeName',
      'employee_email',
      'employee_mobile',
      'status',
    ],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Mobile',
        key: 'employee_mobile',
      },
    },
  }

  const actionConfig = [
    {
      name: 'Remove',
      color: 'red',
      action: (id) => {
        removeEmployeesFromGroup(id)
      },
    },
  ]

  const bulkActionConfig = [
    {
      label: 'Remove',
      value: 'active',
      action: (data) => {
        let newData = data.split(',')
        let result = []

        newData.forEach((id) => {
          let index = group_employees.data.findIndex((item) => item.id == id)
          if (index != -1) {
            result.push(group_employees.data[index].employee)
          }
        })
        removeFromGroup({
          group: group_employees.id,
          employees: result.join(','),
        })
      },
    },
  ]

  return (
    <div className='flex flex-col bg-white shadow-md rounded'>
      {/* {showBasicPayrollOptions ? (
            <RunBasicPayroll
            isOpen={showBasicPayrollOptions}
            source='group'
            sourceData={id}
            closeModal={() => setShowBasicPayrollOptions(false)}
          />
      ): null} */}

      {showAdvancedPayrollOptions ? (
        <RunAdvancedPayroll
          isOpen={showAdvancedPayrollOptions}
          source='group'
          sourceData={id}
          closeModal={() => setShowAdvancedPayrollOptions(false)}
        />
      ) : null}

      {basicPayroll ? (
        <RunBasicPayroll
          isOpen={basicPayroll}
          source='group'
          sourceData={id}
          closeModal={() => setBasicPayroll(false)}
        />
      ) : null}

      {showAddEmployeeToGroup ? (
        <AddEmployeeToGroup
          isOpen={showAddEmployeeToGroup}
          groupData={group}
          closeModal={() => setShowAddEmployeeToGroup(false)}
        />
      ) : null}

      <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
        <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 w-full'>
          Employees list
        </div>
        <div className='flex flex-col md:flex-row items-center gap-[10px] w-full'>
          <div className='w-fit'>
            <Button
              text='Run Payroll'
              type='button'
              className='flex gap-2 !h-[35px] w-fit px-2 items-center'
              textClass={'!text-[11px]'}
              leftIcon={'purchase'}
              theme='primary'
              onClick={() => {
                if (employeeSalaries?.data.length > 0) {
                  setShowAdvancedPayrollOptions(true)
                } else {
                  store.dispatch(
                    setAlert(
                      true,
                      'info',
                      'No Active Employee Compensation to run'
                    )
                  )
                }
              }}
            />
          </div>
          {user?.permissions.payroll_permission?.basic_payroll_write === 1 ||
          user?.permissions.company_permission.role === 'Owner' ? (
            <div className='w-fit' id='second-step'>
              <Button
                text='Make Employee Payment'
                type='button'
                theme='primary'
                className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
                textClass={'!text-[11px]'}
                leftIcon={'purchase'}
                onClick={() => {
                  setBasicPayroll(true)
                }}
              />
            </div>
          ) : null}
          {employees?.data?.length > 0 ? (
            <div className='w-fit'>
              <Button
                text='Add Employee To Group'
                type='button'
                className='flex gap-2 !h-[35px] w-fit px-2 '
                textClass={'!text-[11px]'}
                leftIcon={'add'}
                onClick={() => setShowAddEmployeeToGroup(true)}
              />
            </div>
          ) : null}
        </div>
      </div>
      <hr className='divider mt-2 mb-2' />
      <DataTable
        data={group_employees}
        tableConfig={tableConfig}
        bulkActionConfig={bulkActionConfig}
        statusConfig={employeeStatusConfig}
        searchData={true}
        filterByStatus={true}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
      />
    </div>
  )
}

export default GroupOverviewTab
